'use client';

import { DynamicWidget, useDynamicContext } from '@dynamic-labs/sdk-react-core';
import { ReactElement, useMemo } from 'react';

import { HomeButton } from '@/components/buttons/HomeButton';
import ThemeSwitcher from '@/components/ThemeSwitcher';

const Header = (): ReactElement => {
  const { primaryWallet } = useDynamicContext();
  const isAuthenticated = useMemo(() => !!primaryWallet, [primaryWallet]);

  return (
    <header
      className="tw:sticky tw:top-0 tw:w-full tw:z-[1100] tw:backdrop-blur-[10px] tw:bg-background/80"
      style={{ gridArea: 'header' }}
    >
      <nav className="tw:flex tw:flex-row tw:items-center tw:justify-between tw:p-2 tw:px-6">
        <HomeButton />

        <div className="tw:flex tw:flex-row tw:gap-4 tw:items-center">
          <ThemeSwitcher />
          {isAuthenticated && <DynamicWidget />}
        </div>
      </nav>
    </header>
  );
};

export default Header;
